import React, { Component } from 'react'
import Translation from '../../Translation/cont/Translation'

const SECTIONS = [
    { id: 'general',         label: <Translation id="social_media_section_general" /> },
    { id: 'background',      label: <Translation id="style_newsletterBackground" /> },
    { id: 'border',          label: <Translation id="social_media_border" /> },
    { id: 'gradient',        label: <Translation id="social_media_gradient_overlay" /> },
    { id: 'title',           label: <Translation id="advertisement_title" /> },
    { id: 'freetext',        label: <Translation id="social_media_free_text" /> },
    { id: 'datetime',        label: <Translation id="social_media_section_datetime" /> },
    { id: 'badge',           label: <Translation id="social_media_stoerer" /> },
    { id: 'fsk',             label: <Translation id="social_media_rating_badge" /> },
    { id: 'logo',            label: <Translation id="logo" /> },
    { id: 'cta',             label: <Translation id="social_media_cta" /> },
    { id: 'followup',        label: <Translation id="social_media_section_followup" /> },
]

class PresetSectionNav extends Component {
    render() {
        const { activeSection, onSectionChange } = this.props
        return (
            <nav className="preset-section-nav">
                {SECTIONS.map(section => (
                    <button
                        key={section.id}
                        className={`preset-section-nav__item${activeSection === section.id ? ' preset-section-nav__item--active' : ''}`}
                        onClick={() => onSectionChange(section.id)}>
                        {section.label}
                    </button>
                ))}
            </nav>
        )
    }
}

export { SECTIONS }
export default PresetSectionNav
